import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addMessage, fetchResponse } from "../../store/chatSlice";
import { AppDispatch, RootState } from "../../store/store";
import { addMessageBenchmarking, fetchResponseBenchmarking } from "../../store/chatSliceBenchmarking";
import { FormControl, Select, MenuItem, InputLabel, SelectChangeEvent } from "@mui/material";
import { Modal } from '@appkit4/react-components/modal';
import UploadSample from '../MessageInput/Uploadform';
import $ from 'jquery';
import LoaderSVG from "../TypingEffect/loadersvg";
import { Button } from '@appkit4/react-components/button';
import { Tooltip } from '@appkit4/react-components/tooltip';

interface MessageInputProps {
    isIDMUpload: boolean,
    currentModule: 'benchmarking' | 'idm' | 'draftgeneration'
}
const MessageInput: React.FC<MessageInputProps> = ({ isIDMUpload, currentModule }) => {
    const [message, setMessage] = useState<string>('');
    const [loading, setLoading] = useState<Boolean>(false);
    const dispatch = useDispatch<AppDispatch>()
    const historyBenchmarking = useSelector((state: RootState) => state.chatBenchmarking.history)
    const [switchStatus, setSwitchStatus] = useState<string>('3');
    const [input, setInput] = useState<string>('')
    const textareaRef = useRef<HTMLTextAreaElement>(null)
    const containerRef = useRef<HTMLDivElement>(null)
    const typingMessage = useSelector((state: RootState) => state.chat.typingMessage)
    const typingMessageBenchmarking = useSelector((state: RootState) => state.chatBenchmarking.typingMessage)
    const [visible, setVisible] = React.useState(false);
    const azuresearchId = useSelector((state: RootState) => state.auth.azuresearchId)

    const handleSwitchChange = (event: SelectChangeEvent) => {
        setSwitchStatus(event.target.value as string)
    }

    const handleClick = () => {
        window.open('https://drive.google.com/drive/folders/1f373pYCeH6wOa3YddVHvc_ysE2ksbRd1', '_blank');
    };

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setInput(event.target.value)

    }
    const currentMsgDate = new Date().toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });

    const handleSubmit = () => {
        if (input.trim() && currentModule === 'idm') {
            dispatch(addMessage({ message: input, sender: 'user', currentModule: 'idm', msgDateTime: currentMsgDate }));
            dispatch(fetchResponse({ msge: input, switchStatus, azuresearchId: azuresearchId }));
            setInput('')
        }
        if (input.trim() && currentModule === 'benchmarking') {
            dispatch(addMessageBenchmarking({ message: input, sender: 'user', currentModule: 'benchmarking' }));
            dispatch(fetchResponseBenchmarking({ msge: input, history: historyBenchmarking }));
            setInput('')
        }
    }
    const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {

        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            handleSubmit();
        }
    }

    const closeFileUploadModel = () =>
        setTimeout(() => {
            setVisible(false);
        }, 1000);
    $('.ap-fileupload-fileList').hide()

    const handleKeywordKeypress = (event: any) => {
        event.preventDefault();
        handleSubmit();
    };

    useEffect(() => {
        const textarea = textareaRef.current;
        const container = containerRef.current;


        if (textarea && container) {
            textarea.style.height = 'auto';


            if (textarea.scrollHeight > 150) {

                textarea.style.overflowY = 'visible'
                textarea.style.height = 150 + 'px'
            }

            else {
                textarea.style.overflowY = 'hidden'
                const newheight = textarea.scrollHeight + 'px'
                textarea.style.height = newheight
            }

        }
    }, [input])

    return (
        <div className="message-input">
            <div ref={containerRef} className="message-input-container">

                <div className="searchData">
                    <textarea
                        ref={textareaRef}
                        value={input}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        placeholder='Message Pensions Digital Assistant'
                        className="message-input-textarea"
                        rows={1}
                        disabled={typingMessage !== null || typingMessageBenchmarking !== null}
                    />
                </div>

                <div className="message-options-container" style={{ display: 'flex' }}>
                    {
                        isIDMUpload ? <div className="idm-upload-button" >
                            <Tooltip
                                trigger='hover'
                                position='top-right'
                                distance={4}
                                id="tooltipDesc"
                                content='Upload Files'>
                                <span onClick={() => setVisible(true)} >{loading ? <LoaderSVG width={'2em'} height={'2em'} bgcolor={'#f9f9f9'} className={'loadersvg'} /> : <span className="Appkit4-icon icon-hyperlink-fill"></span>}</span>                               </Tooltip>

                            <Modal
                                visible={visible}
                                onCancel={() => setVisible(false)}
                                modalStyle={{ width: '33.75rem' }}
                                footerStyle={{ 'paddingTop': '8px', 'marginTop': '-8px', 'minHeight': '64px' }}
                                header={""}
                                icons={""}
                                bodyStyle={{ minHeight: '92px' }}
                            >
                                {
                                }
                                <UploadSample closeDataModel={closeFileUploadModel}></UploadSample>
                            </Modal>
                        </div>
                            : <></>
                    }
                    <Tooltip
                        trigger='hover'
                        position='top-right'
                        distance={4}
                        id="tooltipDesc"
                        content='Send Query'>
                        <span onClick={handleKeywordKeypress} className="Appkit4-icon icon-paper-airplane-fill sendButton"></span>
                    </Tooltip>
                    {
                        isIDMUpload ?
                            <div style={{ display: 'flex', gap: '5px' }}>
                                <div>
                                    <FormControl style={{ width: '210px' }} variant="outlined">
                                        <InputLabel id="demo-simple-select-label">Connect and fetch results from:</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={switchStatus}
                                            label="Connect and fetch results from:"
                                            onChange={handleSwitchChange}
                                            sx={{ height: 50 }}
                                        >
                                            <MenuItem value={1}>Only Permanent Storage</MenuItem>
                                            <MenuItem value={2}>Only User Uploaded</MenuItem>
                                            <MenuItem value={3}>All Documents (Both)</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div>
                                    <Tooltip
                                        trigger='hover'
                                        position='top-right'
                                        distance={4}
                                        id="tooltipDesc"
                                        content='Access all files in the permanent storage'>

                                        <Button
                                            kind="primary"
                                            className="round-button"
                                            onClick={handleClick}>
                                            <span className="Appkit4-icon icon-document-text-outline"></span>
                                        </Button>
                                    </Tooltip>
                                </div>
                            </div>
                            : <></>
                    }
                </div>
            </div>
            <div className="bottomText">
                <p>AI-generated content may not always be fully accurate and requires human review.</p>
            </div>
        </div>
    )
}

export default MessageInput